/**
 * True only for absolute `http(s)` URLs.
 *
 * Guards an `href` against dangerous schemes (`javascript:`, `data:`, `vbscript:`,
 * …) when the URL is untrusted or LLM-surfaced — React does NOT neutralize
 * dangerous href schemes, so a crafted URL would execute on click. Callers should
 * fall back to a non-link render when this returns false.
 *
 * SSR-safe (no `window`); rejects relative/protocol-relative URLs (absolute only).
 */
export function isSafeHttpUrl(url: string | undefined | null): url is string {
  if (!url) return false;
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
